import * as cartActions from "./cart.actions";
import { Action, createReducer, on } from "@ngrx/store";
import { CartState } from "./cart.state";
import { mobileCost } from "../helpers/mobile/mobile.helper";

const initialState: CartState = {
	products: {
		mobile: null,
		currentProduct: null,
	},
	address: null,
	dueToday: 0,
	monthlyCost: 0,
};

const featureReducer = createReducer(
	initialState,
	on(cartActions.setMobileCart, (state, { cart }) => {
		const cost = mobileCost({
			...cart?.mobile,
			addons: state?.products?.mobile?.addons,
		});
		return {
			...state,
			products: {
				...state?.products,
				mobile: {
					...state?.products?.mobile,
					basePlan: cart?.mobile?.basePlan,
					dueToday: cost?.dueToday,
					monthlyCost: cost?.monthlyCost,
				},
			},
			dueToday: cost?.dueToday,
			monthlyCost: cost?.monthlyCost,
		};
	}),
	on(cartActions.setMobileCartTemporary, (state, { dueToday, details }) => {
		return {
			...state,
			products: {
				...state?.products,
				mobile: {
					...state?.products?.mobile,
					details,
					dueToday: dueToday,
					monthlyCost: details.monthlyCost,
				},
			},
			dueToday: 0,
			monthlyCost: details.monthlyCost,
		};
	}),
	on(cartActions.setMobileAddonsCart, (state, { cart }) => {
		const cost = mobileCost({
			...cart.mobile,
			basePlan: state?.products?.mobile?.basePlan,
		});
		return {
			...state,
			products: {
				...state?.products,
				mobile: {
					...state?.products?.mobile,
					addons: cart?.mobile?.addons,
					dueToday: cost?.dueToday,
					monthlyCost: cost?.monthlyCost,
				},
			},
			dueToday: cost?.dueToday,
			monthlyCost: cost?.monthlyCost,
		};
	}),
	on(cartActions.setAddressCart, (state, { address }) => {
		return {
			...state,
			address,
		};
	}),
	on(cartActions.setCartProductName, (state, { currentProduct }) => {
		return {
			...state,
			products: {
				...state?.products,
				currentProduct,
			},
		};
	}),
		on(cartActions.setSimType, (state, { simType }) => {
		return {
			...state,
			simType,
		};
	}),
);

export function cartReducer(
	state: CartState | undefined,
	action: Action
): CartState | undefined {
	return featureReducer(state, action);
}

// export function cartReducer(state = initialState, action: any): CartState {
// 	console.log("here in action", action.type, action);
// 	switch (action.type) {
// 		case cartActions.SET_MOBILE_CART: {
// 			const cost = mobileCost({
// 				...action.payload.cart?.mobile,
// 				addons: state?.products?.mobile?.addons,
// 			});
// 			return {
// 				...state,
// 				products: {
// 					...state?.products,
// 					mobile: {
// 						...state?.products?.mobile,
// 						basePlan: action.payload.cart?.mobile?.basePlan,
// 						dueToday: cost?.dueToday,
// 						monthlyCost: cost?.monthlyCost,
// 					},
// 				},
// 				dueToday: cost?.dueToday,
// 				monthlyCost: cost?.monthlyCost,
// 			};
// 		}
// 		// case cartActions.setMobileCartTemporary: {
// 		// }
// 		// case cartActions.setMobileAddonsCart: {
// 		// }
// 		// case cartActions.setEnergyCart: {
// 		// }
// 		// case cartActions.setMobileAddonsCart: {
// 		// }
// 		case cartActions.SET_CART_PRODUCT_NAME: {
// 			console.log("hereinnnn set product name");
// 			return {
// 				...state,
// 				products: {
// 					...state?.products,
// 					currentProduct: action.currentProduct,
// 				},
// 			};
// 		}
// 	}
// 	console.log("final state");
// 	return state;
// }
